import React from 'react';
import { Switch, Route } from 'react-router-dom'
import { loadable } from '@/util/loadable'; //懒加载模块
import AuthRouter from '@/pages/auth/AuthRouter';

const App = loadable({loader: () => import('../App')});
// const Order = loadable({loader: () => import('@/pages/order')});
const Login = loadable({loader: () => import('@/pages/login')})
const Main = loadable({loader: () => import('@/pages/main')})
const Certificate = loadable({loader: () => import('@/pages/certificate')})
const ApjobPrint = loadable({loader: () => import('@/pages/way/apjobPrint')}) // 作业单打印
function RouterConfig (props) {
  return (
    <App>
      <Switch>
        {/* <Redirect exact from="/" to="/login" /> */}
        <Route exact path="/login" component={Login}/>
        <Route exact path="/certificate" component={Certificate}/>
        {/*过滤token权限路由*/}
        <Route exact path="/way/apjobPrint" component={ApjobPrint}/>
        <AuthRouter path="/" component={Main} />
        {/* <Route path="/" render={(props)=>
          <Main>
            <Switch>
              <Redirect exact from="/" to='/user' />
              <Route path="/order" component={Order} />
              <Route path="/user" component={User} />
              <Route path="/waybill" component={Waybill} />
              <Route path="/sys/usermgr" component={Usermgr} />
              <Route path="/sys/orgmgr" component={Org} />
              <Route path="/sys/rolemgr" component={Role} />
              <Route path="/sys/testuser" component={testUser} />
              <Route path="/basic/vehicletype" component={Vehicletype} />
              <Route path="/basic/driver" component={Driver} />
              <Route path="/basic/vehicle" component={Vehicle} />
              <Route path="/basic/station" component={Station} />
              <Route path="/orderAddForm" component={OrderAddForm} />
              <Route component={NotFound} />
            </Switch>
          </Main>
        }/> */}

      </Switch>
    </App>
  )
}
export default RouterConfig;
